import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import FormInput from "../../../common/FormInput";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import OperationTypes from "../../../../types";
import { useContext, useMemo } from "react";
import { AutoCompleteOption } from "../../../common/AutoComplete";
import { useForm } from "react-hook-form";
import { nameof } from "../../../common/ObjectUtils";
import DamageFormService from "../../service/DamageFormService";
import { ContextOperation } from "../../../../context/OperationContext";
import { useLocation } from "react-router-dom";
import { CreateDamageFormTypes } from "../../Types";
import { useTranslation } from "react-i18next";

interface FormInputs {
  evnetId: number;
  counterpart: boolean;
}

interface Props {
    isOpen: boolean;
    onClose: () => void;
    events: OperationTypes.Domain[];
    onEventCreated: (event: CreateDamageFormTypes.IRespCreateEvent) => void;
  }
const CreateEvent = (props: Props) => {
  const { i18n } = useTranslation();
  const t = useOperationTranslation();
  const { tenant, setLoading } = useContext(ContextOperation);

  const locationState = useLocation().state as CreateDamageFormTypes.ISharedLocationState;

  const form = useForm<FormInputs>();

  const onSubmit = (data: FormInputs) => {
    if (!locationState.generalInfo?.plate) {
      return;
    }

    setLoading(true);
    DamageFormService.create.post.addEvent(tenant, {
      formList: [
        {
          counterparty: data.counterpart || false,
          eventId: data.evnetId,
        }
      ],
      plate: locationState.generalInfo?.plate,
      insertionFlow: "SYSTEM_CONSOLE",
      ...(locationState.rentalAgreement?.isAssociated && {
        raOwner: locationState.rentalAgreement?.raOwner,
        raId: locationState.rentalAgreement?.raId
      })
    }).then(
      response => {
        props.onEventCreated(response[0]);
        setLoading(false);
        props.onClose();
      },
      error => {
        setLoading(false);
      }
    )
  }

  const events = useMemo<AutoCompleteOption[]>(() => {
    return props.events.map((event) => ({
      label: t(`masterDataDamage.event.${event.code.replaceAll('.', '_').toLowerCase()}` as any, event.descr),
      value: event.id
    }))
  }, [props.events, i18n.language]);

    return(
        <Mui.Dialog 
            maxWidth="sm"
            fullWidth
            open={props.isOpen} 
            onClose={props.onClose}
        >
      <Mui.DialogTitle>
        <Mui.Grid container columnSpacing={1}>
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h5">
              {t("damageForm.damageFormCreation.dialogs.createEvent.title")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Mui.DialogContent>
          <FormInput 
              name={nameof<FormInputs>("evnetId")}
              type="select"
              options={events}
              label={t("damageForm.damageFormCreation.dialogs.createEvent.event")}
              fullWidth
              formInstance={form}
          />
          <FormInput 
              name={nameof<FormInputs>("counterpart")}
              type="checkbox"
              label={t("damageForm.damageFormCreation.dialogs.createEvent.counterPart")}
              formInstance={form}
          />
        </Mui.DialogContent>

        <Mui.DialogActions>
          <Mui.Button variant="outlined" onClick={props.onClose}>
            {t("damageForm.damageFormCreation.button.cancel")}
          </Mui.Button>

          <Mui.Button variant="contained" type="submit">
            {t("damageForm.damageFormCreation.button.create")}
          </Mui.Button>
        </Mui.DialogActions>
      </form>
    </Mui.Dialog>
    )
}
export default CreateEvent;